import { ReactNode } from "react";
import { PageHeader } from "./PageHeader";

export interface PageLayoutProps {
  children: ReactNode;
  title?: string;
  showBack?: boolean;
  rightAction?: ReactNode;
  leftAction?: ReactNode;
  noHeader?: boolean;
  className?: string;
  onBack?: () => void;
}

export function PageLayout({
  children,
  title,
  showBack = false,
  rightAction,
  leftAction,
  noHeader = false,
  className = "",
}: PageLayoutProps) {
  return (
    <div className={`flex flex-col h-full ${className}`}>
      {!noHeader && (
        <PageHeader
          title={title}
          showBack={showBack}
          rightAction={rightAction}
          leftAction={leftAction}
        />
      )}
      <main className="flex-1 overflow-auto">{children}</main>
    </div>
  );
}
